module.exports = __webpack_public_path__ + "static/sarah-avenir-bio-8b99f70ecd92d30d284c1acecb630692.jpg";